/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 9512eede1b4a
 */

import * as z from "zod";

/**
 * A comma-separated list of tag names, or an array of tag names.
 */
export type TagsParam = string | Array<string>;

export const TagsParam$zodSchema: z.ZodType<TagsParam> = z.union([
  z.string(),
  z.array(z.string()),
]).describe("A comma-separated list of tag names, or an array of tag names.");
